<template>
    <div class="baseBody baseBody-content">
        <ScaleBox>
            <div class="main-wraper relative">
                <div class="custBodybg"></div>
                <div class="dateWeek">
                    <DynamicDate></DynamicDate>
                </div>
                <div class="fullBox">
                    <ScreenfullBox></ScreenfullBox>
                </div>
                <div class="baseTitleContent ">
                    <div class="baseTitleMid" style="width:759px;">
                        <div class="top" style="width:100%;">
                            <div class="topLine" style="width:100%;">
                                <div class="title text-center  text-white text-bold" style="font-size:32px;">{{school.schoolName||''}}学生成长评价看板
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div style="position: fixed;width:100%;left:0;top:0;z-index:999;pointer-events:none;">
                    <div class="flex align-center justify-between">
                        <div>
                            <div class="baseTitleLeft"></div>
                        </div>
                        <div>
                            <div class="baseTitleRight"></div>
                        </div>
                    </div>
                </div>
                <div style="width:25% ;position: fixed;top: 60px;left:0;z-index: 999;">
                    <LeftContent ref="leftContentRef" ></LeftContent>
                </div>
                <div style="width:50% ;position: fixed;top: 60px;left:25%;z-index: 999;">
                    <MidContent ref="ceterContentRef"></MidContent>
                </div>
                <div style="width:25% ;position: fixed;top: 60px;right:0;z-index: 999;">
                    <RightContent ref="rightContentRef"></RightContent>
                </div>
            </div>
        </ScaleBox>
    </div>
</template>

<script>
    import DynamicDate from "../components/dynamicDate/index.vue";
    import ScreenfullBox from "../components/screenfull/index.vue";
    import ScaleBox from "../components/sacleBox/index.vue";
    import LeftContent from './components/school/leftContent.vue'
    import RightContent from './components/school/rightContent.vue'
    import MidContent from './components/school/midContent.vue'
    import {getSchoolInfo} from "@/api/api";
    export default {
        components: {
            LeftContent,
            RightContent,
            ScaleBox,
            DynamicDate,
            ScreenfullBox,
            MidContent,
        },

        data() {
            return {
                timer: null,
              school:"",
              schoolId:''
            }
        },
        mounted() {
          const params = new URLSearchParams(window.location.search);
          console.log("params:"+params);
          this.schoolId = params.get('schoolId');      // 获取单个参数
          console.log("schoolId:"+this.schoolId);
          this.changeData();
          this.$refs.leftContentRef.init(this.schoolId);
          this.$refs.ceterContentRef.init(this.schoolId);
          this.$refs.rightContentRef.init(this.schoolId);
        },
        beforeDestroy() {
            if (this.timer) {
              clearInterval(this.timer);
            }
        },
        methods: {
          async changeData() {
            try {
              const res = await getSchoolInfo(this.schoolId);
              if (res && res.data) {
                this.school=res.data;
              }
            } catch (e) {
              console.log('使用默认数据');
            }
          },
        }
    }
</script>


<style lang="scss">
    .pointer {
        cursor: pointer;
    }

    .baseBody {
        width: 100%;
        height: 100vh;
        overflow: hidden;
        position: relative;
        font-size: 14px;
        background: #000208;
        position: relative;

        .main-wraper {
            user-select: none;
            width: 1920px;
            height: 1080px;
            margin: 0 auto;
            background: #02081a url('../assets/images/sytBg2.png') center no-repeat;
            background-size: cover;
            box-sizing: border-box;
        }

    }

    .dateWeek {
        position: absolute;
        top: 0;
        left: 0;
        width: 200px;
        height: 50px;
        color: #ffffff;
        z-index: 200;
    }

    .fullBox {
        position: absolute;
        top: 0;
        right: 0;
        width: 200px;
        height: 50px;
        color: #ffffff;
        z-index: 999;
    }

    .baseTitleLeft {
        width: 644px;
        height: 55px;
        background: url('../assets/images/titleLeft.png') top right no-repeat;
        background-size: auto 55px
    }

    .baseTitleRight {
        width: 644px;
        height: 55px;
        background: url('../assets/images/titleRight.png') top left no-repeat;
        background-size: auto 55px
    }

    .baseBody .baseTitleContent {
        width: 100%;
        height: 100px;
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        z-index: 200;
    }

    .baseBody .baseTitleContent .baseTitleMid {
        width: 659px;
        height: 100px;
        margin: 0 auto;
        background: url('../assets/images/headtitileBg3.png') top left no-repeat;
        background-size: 100% 100px
    }

    .baseBody .baseTitleContent .baseTitleMid .top {
        width: 659px;
        height: 100px;
        margin: 0 auto;
        background: url('../assets/images/headtitileBg2.png') top center no-repeat;
        background-size: 100% 100px
    }

    .baseBody .baseTitleContent .baseTitleMid .topLine {
        width: 659px;
        height: 100px;
        margin: 0 auto;
        background: url('../assets/images/titleBg4.png') top left no-repeat;
        background-size: auto 100px
    }

    .baseBody .baseTitleContent .baseTitleMid .title {
        width: 100%;
        height: 70px;
        margin: 0 auto;
        font-size: 34px;
        font-weight: bold;
        line-height: 70px;
        background: url('../assets/images/headtitileBg1.png') top center no-repeat;
        background-position: center;
        background-size: 100% auto;
    }

    .custBodybg {
        width: 1920px;
        height: 1080px;
        position: fixed;
        left: 0;
        top: 0;
        z-index: 100;
        pointer-events: none;
        background: -webkit-radial-gradient(rgba(0, 12, 38, 0) 30%, #000c26 100%, #000c26 100%);
        background: -o-radial-gradient(rgba(0, 12, 38, 0) 30%, #000c26 100%, #000c26 100%);
        background: -moz-radial-gradient(rgba(0, 12, 38, 0) 30%, #000c26 100%, #000c26 100%);
        background: radial-gradient(rgba(0, 12, 38, 0) 30%, #000c26 100%, #000c26 100%);
    }
</style>
